'use client';

import { useTranslations } from 'next-intl';
import { SITE_CONFIG } from '@/constants';
import { trackPreferredSourceClick } from '@/src/components/GoogleAnalytics/GoogleAnalytics';
import { GoogleLogoIcon } from '@/src/components/icons';
import { PreferredSourcePlacement } from '@/src/types/preferredSource';

import styles from './PreferredSourceBlock.module.css';

interface PreferredSourceBlockProps {
  placement: PreferredSourcePlacement;
  // The host page owns the box (card, divider, spacing); alignment is inherited from it.
  className?: string;
}

export function PreferredSourceBlock({ placement, className }: PreferredSourceBlockProps) {
  const t = useTranslations('common.preferredSource');

  return (
    <div className={className}>
      {/* Not a heading: it would add the same outline entry to every blog post. */}
      <p className={styles.title}>{t('title')}</p>
      <p className={styles.text}>{t('text')}</p>
      <a
        href={SITE_CONFIG.google.preferredSourceUrl}
        target="_blank"
        rel="noopener noreferrer"
        className={styles.button}
        onClick={() => trackPreferredSourceClick(placement)}
      >
        <GoogleLogoIcon />
        <span>{t('button')}</span>
      </a>
    </div>
  );
}
